// Admin token handling, shared by the standalone /admin page and the in-page
// re-authentication prompt.
const TOKEN_KEY = 'winery_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Returns { ok } on success, or { ok: false, message } to show the user.
export async function login(username, password) {
  try {
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (response.ok && data.success && data.token) {
      setToken(data.token);
      return { ok: true, token: data.token };
    }
    return { ok: false, message: data.message || 'Invalid username or password' };
  } catch (error) {
    console.error('Login error:', error);
    return { ok: false, message: 'Login failed. Please try again.' };
  }
}

// A stored token may have expired or been signed with a secret that has since
// changed, so ask the server rather than trusting localStorage.
export async function validateSession() {
  const token = getToken();
  if (!token) return false;

  try {
    const response = await fetch('/api/auth/session', {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      clearToken();
      return false;
    }
    return true;
  } catch {
    // A network blip is not proof the session is invalid; keep the token.
    return true;
  }
}
